import FormControlLabel from '@mui/material/FormControlLabel';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Switch from '@mui/material/Switch';

import {usePreferencesStore} from '../../common/stores/preferencesStore';
import {useUserStore} from '../../common/stores/userStore';

export default function Profile(): JSX.Element {
  const user = useUserStore();
  const toggleThemeMode = usePreferencesStore((state) => state.toggleThemeMode);
  const isDarkMode = usePreferencesStore((state) => state.themeMode === 'dark');

  return (
    <List>
      <ListItem>
        <ListItemText primary={user.name} secondary="Name" />
      </ListItem>
      <ListItem>
        <ListItemText
          primary={user.preferred_username}
          secondary="Preferred Username"
        />
      </ListItem>
      <ListItem>
        <ListItemText primary={user.family_name} secondary="Family Name" />
      </ListItem>
      <ListItem>
        <ListItemText primary={user.given_name} secondary="Given Name" />
      </ListItem>
      <ListItem>
        <ListItemText primary={user.email} secondary="Email" />
      </ListItem>
      <ListItem>
        <ListItemText
          primary={user.email_verified ? 'Verified' : 'Not Verified'}
          secondary="Email Verified"
        />
      </ListItem>
      <ListItem>
        <FormControlLabel
          control={
            <Switch
              checked={isDarkMode}
              onChange={toggleThemeMode}
              color="primary"
            />
          }
          label={isDarkMode ? 'Dark Theme' : 'Light Theme'}
        />
      </ListItem>
    </List>
  );
}
